/**
 * echarts世界地图静态配置
 */
export const MAP_CHART_STATIC_OPTION = {
  tooltip: {
    padding: 0,
    borderWidth: 0,
    trigger: 'item',
    label: { show: false },
    formatter: void 0,
  },
  visualMap: [
    {
      type: 'piecewise',
      top: '8%',
      left: '1%',
      realtime: false,
      calculable: false,
      inverse: false,
      min: 0,
      max: 10000000000,
      itemGap: 0,
      itemWidth: 14,
      itemHeight: 40,
      itemSymbol: 'rect',
      textStyle: {
        lineHeight: 40,
        fontSize: 14,
        color: '#838697',
      },
      // 点击后的颜色
      outOfRange: {
        color: '#ffdf33',
        symbolSize: [30, 100],
      },
      pieces: [],
    },
  ],
  series: [
    {
      type: 'map',
      mapType: 'world',
      roam: 'move',
      itemStyle: {
        normal: {
          borderWidth: 1,
          borderColor: 'rgba(190, 190, 190,0.5)',
          areaColor: '#f2f2f2',
        },
        emphasis: {
          label: { show: false },
          itemStyle: {
            borderType: 'solid',
            borderWidth: '2',
            borderColor: '#000',
            shadowBlur: 10,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
      data: [],
    },
  ],
} as any as IEChartOption;
